'use client'

import { BreadcrumbItem, BreadcrumbsWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import { css } from '@lastbrand/web-ui-styled-system/css'

import { BreadcrumbsDS } from '@src/components/blocks/breadcrumb-ds'
import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { SectionContentContainer } from '@src/ds/blocks/section-content-container'
import Directory, { Path } from '@src/quince-site-common/src/domains/Directory'
import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'

// Vertical spacing for the breadcrumb widget. `SectionContentContainer` owns the
// shared content frame (`px` gutter + `max-w: 1504` centered). Because
// breadcrumbs + title are TWO separate PL widgets, the gap between them
// (Figma `.Widget-PageTitle`, node 3764:14196) lives entirely in margins:
//   - this widget (breadcrumb): mb = gap down to the title
//   - title widget:             mb = gap down to page content
const spacingClass = css({
  mb: { base: 'space-4', lg: 'space-12' },
})

export function BreadcrumbsDSWidget(props: PLTypedWidgetProps<BreadcrumbsWidgetData>) {
  const { deviceType } = useDeviceInfo()

  const breadCrumbs = Array.isArray(props.data.breadCrumbsData?.breadCrumbs)
    ? props.data.breadCrumbsData.breadCrumbs
    : []
  const directory = new Directory({
    paths: breadCrumbs.map(
      (breadcrumb: BreadcrumbItem) =>
        new Path({
          displayName: breadcrumb.name,
          route: breadcrumb.slug,
        }),
    ),
  })

  return (
    <SectionContentContainer data-testid="collection-breadcrumb" className={spacingClass}>
      <BreadcrumbsDS directory={directory} deviceType={deviceType} />
    </SectionContentContainer>
  )
}
